module.exports = __webpack_public_path__ + "img/41.6663e748.jpg";